import App from 'antd/es/app';
import Button from 'antd/es/button';
import Form from 'antd/es/form';
import Input from 'antd/es/input';

import { type Project } from '@mai/types';

import { createProject } from '@queries/projects';

type FormValues = {
  name: string;
};

const CreateProjectForm = ({
  teamId,
  afterSubmit,
  confirmText = 'Create Project',
}: {
  teamId: string;
  afterSubmit: (project: Project) => void;
  confirmText?: string;
}) => {
  const [form] = Form.useForm();
  const { message } = App.useApp();

  const onFinish = async (values: FormValues) => {
    const loading = message.loading('Creating project...');
    try {
      const project = await createProject({
        teamId,
        name: values.name,
      });
      afterSubmit(project);
    } finally {
      loading();
    }
  };

  return (
    <Form form={form} onFinish={onFinish} layout="vertical">
      <Form.Item name="name" label="Name" rules={[{ required: true }]}>
        <Input placeholder="Enter project name..." />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
          {confirmText}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default CreateProjectForm;
